import moment from "moment/moment";
import { useEffect, useState } from "react";
import "react-calendar/dist/Calendar.css";
import DatePicker from "react-date-picker";
import "react-date-picker/dist/DatePicker.css";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { succsesDataDeleteAlert } from "../../alerts/alerts";
import { PaginatedItems } from "../../components/pagination/Pagination";
import useDebounse from "../../helpers/useDebounse";
import { useGetPageQuery, useSendFormMutation } from "../../redux/services/crmAPI";
import "./repairs.scss";

const Repairs = () => {
    const [currentPage, setCurrentPage] = useState(1);

    const permissions = useSelector((state) => state.status.permissions);

    const [repairsList, setRepairsList] = useState([]);

    const [fromDate, setFromDate] = useState(new Date());
    const [startDateSearchValue, setStartDateSearchValue] = useState("");
    const [toDate, setToDate] = useState(new Date());
    const [endDateSearchValue, setEndDateSearchValue] = useState("");

    const [search, setSearch] = useState("");
    const [warranty, setWarranty] = useState("");
    const [repairStatus, setRepairStatus] = useState(1);
    const [selectedShipper, setSelectedShipper] = useState("");
    const [selectedStore, setSelectedStore] = useState("");

    const debounceSearch = useDebounse(search, 1000);

    const warrantyQwery = warranty ? "&is_warranty=" + warranty : "";
    const repairStatusQwery = "&repair_status_id=" + repairStatus;
    const shipperQwery = selectedShipper ? "&shipper_id=" + selectedShipper : "";
    const storesQwery = selectedStore ? "&store_id=" + selectedStore : "";
    const fromDateQwery = startDateSearchValue ? "&start_date=" + startDateSearchValue : "";
    const toDateQwery = endDateSearchValue ? "&end_date=" + endDateSearchValue : "";
    const searchQwery = search.length > 0 ? `&search=${debounceSearch}` : "";
    const pagination = "&page=" + currentPage;

    const combinedQwery =
        repairStatusQwery +
        warrantyQwery +
        shipperQwery +
        storesQwery +
        fromDateQwery +
        toDateQwery +
        searchQwery +
        pagination;

    const { data: repairs, refetch: refetchRepairs } = useGetPageQuery("repairs?per_page=40" + combinedQwery);
    const { data: repairStatuses } = useGetPageQuery("repair-statuses");
    const { data: shippers } = useGetPageQuery("shippers");
    const { data: stores } = useGetPageQuery("stores?per_page=200");
    const [deleteRetairs, { isLoading, isError }] = useSendFormMutation();

    const onDateSearchHandler = () => {
        setStartDateSearchValue(moment(fromDate).format("DD.MM.YYYY"));
        setEndDateSearchValue(moment(toDate).format("DD.MM.YYYY"));
    };

    const deleteProductsHandler = async () => {
        for (const repair of repairsList) {
            await deleteRetairs({ body: {}, url: "repairs/" + repair, method: "DELETE" });
        }

        if (!isError) {
            succsesDataDeleteAlert();
        }

        await refetchRepairs();
    };

    const checkAllHandler = () => {
        setRepairsList(repairs.data.map((user) => user.id.toString()));
    };

    const listCheckHandler = (e) => {
        if (e.target.checked) {
            setRepairsList([...repairsList, e.target.value]);
        } else if (!e.target.checked) {
            setRepairsList([...repairsList.filter((id) => id !== e.target.value)]);
        }
    };

    useEffect(() => {
        const refetch = async () => {
            await refetchRepairs();
        };
        refetch();
    }, [repairs]);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            {repairs && repairStatuses && shippers && stores && (
                <div className="content">
                    <div className="col-12">
                        <div className="page-header d-flex justify-content-between align-items-center mb-3">
                            <div className="header">
                                <h1>{repairs.total} ремонтів</h1>
                            </div>
                            <div className="page-header__button">
                                <div className="float-right">
                                    <Link to="/repair" className="add btn btn-primary">
                                        Додати ремонт
                                    </Link>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12 col-sm-6 col-md-9">
                                <div>
                                    <a className="check_all" onClick={checkAllHandler}>
                                        Виділити все
                                    </a>
                                    <table className="table table-striped">
                                        <thead>
                                            <tr>
                                                <th data-field="check"></th>
                                                <th data-field="id">ID</th>
                                                <th data-field="user_name">Клієнт</th>
                                                <th data-field="user_name" className="no-mobile">
                                                    Пристрій
                                                </th>
                                                <th data-field="user_date" className="no-mobile">
                                                    Створено
                                                </th>
                                                <th data-field="user_address" className="no-mobile">
                                                    Ціна
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {repairs.data.map((repair) => {
                                                return (
                                                    <tr key={repair.id}>
                                                        <td className="check_area text-right">
                                                            <div className="custom-control custom-checkbox">
                                                                <input
                                                                    className="form-check-input"
                                                                    type="checkbox"
                                                                    checked={repairsList.includes(repair.id.toString())}
                                                                    value={repair.id}
                                                                    onChange={(e) => listCheckHandler(e)}
                                                                />
                                                                <label className="custom-control-label">&nbsp;</label>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <Link to={"/repair/" + repair.id} data-id="31602">
                                                                Ремонт&nbsp;#{repair.id}
                                                            </Link>
                                                            <div>
                                                                {repair.is_warranty ? (
                                                                    <span className="badge bg-danger badge-model">
                                                                        Гарантійний
                                                                    </span>
                                                                ) : null}
                                                            </div>
                                                            {repair.pincode ? (
                                                                <div className="badge bg-primary ">
                                                                    <i className="bi bi-lock-fill mx-1"></i>
                                                                    {repair.pincode}
                                                                </div>
                                                            ) : null}
                                                        </td>
                                                        <td>
                                                            {repair.client_name}
                                                            <br />
                                                            {repair.client_phone}
                                                        </td>
                                                        <td className="no-mobile">
                                                            {repair.device} ({repair.imei.slice(repair.imei.length - 5)}
                                                            ) ({repair.imei})
                                                            {repair.note_client ? (
                                                                <div className="note note-status">
                                                                    {repair.note_client}
                                                                </div>
                                                            ) : null}
                                                            {repair.note_master ? (
                                                                <div className="note note-status">
                                                                    {repair.note_master}
                                                                </div>
                                                            ) : null}
                                                        </td>
                                                        <td className="no-mobile">
                                                            {moment(repair.created_at).format("DD.MM.YYYY HH:MM")}
                                                        </td>
                                                        <td className="no-mobile">{repair.price}&nbsp;грн</td>
                                                    </tr>
                                                );
                                            })}
                                        </tbody>
                                    </table>
                                    {permissions.includes("repair_edit") || permissions.includes("all") ? (
                                        <div className="d-flex mb-3">
                                            <select name="action" className="form-select" style={{ width: "auto" }}>
                                                <option value="delete">Видалити</option>{" "}
                                            </select>
                                            <button className="btn btn-info mx-3" onClick={deleteProductsHandler}>
                                                {isLoading ? "Завантаження" : "Виконати"}
                                            </button>
                                        </div>
                                    ) : null}
                                </div>
                                <nav>
                                    <PaginatedItems pageCount={repairs.last_page} setCurrentPage={setCurrentPage} />
                                </nav>
                            </div>
                            <div className="col-12 col-sm-6 col-md-3">
                                <div className="margin20">
                                    <div className="input-group">
                                        <div className="input-group">
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Пошук..."
                                                onChange={(e) => setSearch(e.target.value)}
                                                value={search}
                                            />
                                            <button
                                                className="btn btn-outline-secondary"
                                                type="button"
                                                id="button-addon2"
                                            >
                                                <i className="bi bi-search"></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <div className="card card-default mt-2">
                                        <div className="card-header">Виберіть дату</div>
                                        <div className="card-body datas">
                                            <div className="input-group">
                                                <span className="input-group-prepend" id="date_from">
                                                    <span className="input-group-text">Від</span>
                                                </span>
                                                <DatePicker
                                                    onChange={setFromDate}
                                                    value={fromDate}
                                                    format="dd.MM.yyyy"
                                                    locale="uk-UA"
                                                    className="custom-input"
                                                />
                                            </div>
                                            <div className="input-group">
                                                {" "}
                                                <span className="input-group-prepend" id="date_to">
                                                    <span className="input-group-text">До</span>
                                                </span>
                                                <DatePicker
                                                    onChange={setToDate}
                                                    value={toDate}
                                                    format="dd.MM.yyyy"
                                                    locale="uk-UA"
                                                    className="custom-input"
                                                />
                                            </div>
                                            <button
                                                className="btn btn-primary form-control my-2"
                                                onClick={onDateSearchHandler}
                                            >
                                                Вибрати
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div className="list-group list-group-horizontal-sm margin20">
                                    <div
                                        className={
                                            warranty === ""
                                                ? "list-group-item flex-fill fake-a active"
                                                : "list-group-item flex-fill fake-a"
                                        }
                                        onClick={() => setWarranty("")}
                                    >
                                        Всі
                                    </div>
                                    <div
                                        className={
                                            warranty === 1
                                                ? "list-group-item flex-fill fake-a active"
                                                : "list-group-item flex-fill fake-a"
                                        }
                                        onClick={() => setWarranty(1)}
                                    >
                                        Гарантійні
                                    </div>
                                    <div
                                        className={
                                            warranty === 0
                                                ? "list-group-item flex-fill fake-a active"
                                                : "list-group-item flex-fill fake-a"
                                        }
                                        onClick={() => setWarranty(0)}
                                    >
                                        Не гарантійні
                                    </div>
                                </div>
                                <div className="list-group margin20">
                                    {repairStatuses.map((status) => {
                                        return (
                                            <div
                                                className={
                                                    status.id === repairStatus
                                                        ? "list-group-item fake-a active"
                                                        : "list-group-item fake-a"
                                                }
                                                onClick={() => setRepairStatus(status.id)}
                                                key={status.id}
                                            >
                                                {status.title}
                                            </div>
                                        );
                                    })}
                                </div>
                                <div className="list-group margin20">
                                    <div
                                        className={
                                            selectedShipper === ""
                                                ? "list-group-item fake-a active"
                                                : "list-group-item fake-a"
                                        }
                                        onClick={() => setSelectedShipper("")}
                                    >
                                        Всі ремонти
                                    </div>
                                    {shippers.data.map((shipper) => {
                                        return (
                                            <div
                                                className={
                                                    selectedShipper === shipper.id
                                                        ? "list-group-item fake-a active"
                                                        : "list-group-item fake-a"
                                                }
                                                onClick={() => setSelectedShipper(shipper.id)}
                                                key={shipper.id}
                                            >
                                                {shipper.title_short}
                                            </div>
                                        );
                                    })}
                                </div>
                                <div className="list-group margin20">
                                    <div
                                        className={
                                            selectedStore === ""
                                                ? "list-group-item fake-a active"
                                                : "list-group-item fake-a"
                                        }
                                        onClick={() => setSelectedStore("")}
                                    >
                                        Всі магазини
                                    </div>
                                    {stores.data.map((store) => {
                                        return (
                                            <div
                                                className={
                                                    selectedStore === store.id
                                                        ? "list-group-item fake-a active"
                                                        : "list-group-item fake-a"
                                                }
                                                onClick={() => setSelectedStore(store.id)}
                                                key={store.id}
                                            >
                                                {store.title}
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default Repairs;
